import React from 'react';

const LogoMark = () => (
  <svg className="logo-mark" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <rect x="15" y="35" width="70" height="45" rx="6" fill="none" stroke="#1E40AF" strokeWidth="4"/>
    <line x1="15" y1="50" x2="85" y2="50" stroke="#14B8A6" strokeWidth="4"/>
    <rect x="25" y="60" width="18" height="12" rx="2" fill="#F59E0B"/>
    <line x1="55" y1="65" x2="75" y2="65" stroke="#1E40AF" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const SunIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
    <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
  </svg>
);

const MoonIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
);

const Navbar = ({ theme, toggleTheme, navigateTo, scrollToSection }) => (
  <nav className="navbar" id="navbar">
    <div className="nav-brand" onClick={() => navigateTo('home')}>
      <LogoMark />
      <span className="nav-logo-text">SequPay</span>
    </div>
    <div className="nav-links">
      <button className="nav-link" onClick={() => scrollToSection('features')}>Features</button>
      <button className="nav-link" onClick={() => scrollToSection('security')}>Security</button>
      <button className="nav-link" onClick={() => scrollToSection('roadmap')}>Roadmap</button>
      <button className="nav-link" onClick={() => navigateTo('privacy')}>Privacy</button>
      <button className="nav-link" onClick={() => navigateTo('terms')}>Terms</button>
    </div>
    <div className="nav-right">
      <button className="nav-danger" onClick={() => navigateTo('delete')}>Delete Account</button>
      <span className="nav-badge">Early Access · Android</span>
      <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
        {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
      </button>
      <button className="nav-cta" onClick={() => scrollToSection('dl-section')}>Download App</button>
    </div>
  </nav>
);

export default Navbar;
